<div id="main-feed-div">
  @if (isUserAdmin()) {
    <div id="create-post-div">
      <button mat-flat-button color="primary" (click)="openNewPostDialog()">
        Admin Create Post
      </button>
    </div>
  }

  <app-feed
    feedLocation="Main"
    [(shouldFetchPosts)]="shouldFetchPosts"
  ></app-feed>
</div>
